import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ToastContext = createContext({
  notify: () => {},
});

let idCounter = 0;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const remove = useCallback((id) => {
    setToasts((items) => items.filter((t) => t.id !== id));
  }, []);

  const notify = useCallback((message, options = {}) => {
    const id = ++idCounter;
    const toast = {
      id,
      message,
      type: options.type || 'info',
      duration: options.duration || 3500,
    };
    setToasts((items) => [...items, toast]);
    if (toast.duration > 0) {
      setTimeout(() => remove(id), toast.duration);
    }
    return id;
  }, [remove]);

  const value = useMemo(() => ({ notify }), [notify]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      {/* Toast container */}
      <div className="fixed top-5 right-5 z-[100] space-y-3">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`pointer-events-auto max-w-sm w-80 rounded-xl shadow-lg border px-4 py-3 text-left backdrop-blur-sm transition transform bg-white/95 ${
              t.type === 'success' ? 'border-green-200' : t.type === 'error' ? 'border-red-200' : 'border-gray-200'
            }`}
          >
            <div className="flex items-start">
              <div className={`mt-0.5 mr-3 h-2.5 w-2.5 rounded-full ${
                t.type === 'success' ? 'bg-green-500' : t.type === 'error' ? 'bg-red-500' : 'bg-indigo-500'
              }`}></div>
              <div className="flex-1 text-sm text-gray-800">{t.message}</div>
              <button onClick={() => remove(t.id)} className="ml-3 text-gray-400 hover:text-gray-600">×</button>
            </div>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);

export default ToastProvider;


